(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8818,5858],{

/***/ 81299:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/album",
      function () {
        return __webpack_require__(20276);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ page; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var page = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    pageId: -1,
    isMobile: 0,
    isTablet: 0,
    isDesktop: 0,
    isPublicDomain: 0,
    appSettings: [],
    destinationId: null,
    propertiesParams: {
        page_id: null,
        limit: 24,
        offset: 0,
        destinations: [],
        tags: [],
        themes: [],
        locations: [],
        statuses: 3
    }
});


/***/ }),

/***/ 33030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ViewPort; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function ViewPort(props) {
    var myRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((props === null || props === void 0 ? void 0 : props.viewPort) ? props.viewPort : false), inViewPort = ref[0], setInViewPort = ref[1];
    // CHECK IF WHOLE ELEMENT IS IN VIEWPORT
    // const inWholeViewPortUpdate = useCallback( ( myRef, windowWidth, windowHeight ) => {
    //   let refDiv;
    //   if ( myRef.current ) {
    //     refDiv = myRef.current.getBoundingClientRect();
    //     if ( refDiv.top >= 0 && refDiv.left >= 0 && refDiv.right <= windowWidth && refDiv.bottom <= ( windowHeight - refDiv.bottom ) ) {
    //       setInViewPort( true );
    //     } else {
    //       setInViewPort( false );
    //     }
    //   }
    // }, []);
    // CHECK IF ANY PART OF THE ELEMENT IS IN VIEWPORT
    var inAnyViewPortUpdate = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(myRef, windowWidth, windowHeight, windowPageXOffset, windowPageYOffset) {
        var refDiv;
        if (myRef.current) {
            refDiv = myRef.current;
            var top = refDiv.offsetTop;
            var left = refDiv.offsetLeft;
            var width = refDiv.offsetWidth;
            var height = refDiv.offsetHeight;
            while(refDiv.offsetParent){
                refDiv = refDiv.offsetParent;
                top += refDiv.offsetTop;
                left += refDiv.offsetLeft;
            }
            if (top < windowPageYOffset + windowHeight && left < windowPageXOffset + windowWidth && top + height > windowPageYOffset && left + width > windowPageXOffset) {
                setInViewPort(true);
            } else {
                setTimeout(function() {
                    setInViewPort(true);
                }, 200);
            }
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (document !== undefined && window !== undefined) {
            inAnyViewPortUpdate(myRef, window.innerWidth, window.innerHeight, window.pageXOffset, window.pageYOffset);
            window.addEventListener("scroll", function() {
                inAnyViewPortUpdate(myRef, this.innerWidth, this.innerHeight, this.pageXOffset, this.pageYOffset);
            });
        }
    }, [
        inAnyViewPortUpdate
    ]);
    if (!inViewPort) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: props.id ? props.id : "",
            ref: myRef,
            className: props === null || props === void 0 ? void 0 : props.parentClassName,
            children: props === null || props === void 0 ? void 0 : props.skeletonItem
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: props.children
    });
}


/***/ }),

/***/ 948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55791);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var _helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28695);








function BuilderHead(props) {
    var isRateParityWebAppPage = props.hasOwnProperty("isRateParityWebAppPage") ? props.isRateParityWebAppPage : false;
    var manifestPath = "/manifest.json";
    if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].booleanState */ .Z.booleanState(props.property)) {
        manifestPath = "../../" + manifestPath.split("/")[1];
    }
    var showRateParityWidget = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_general_show_rateparity_widget") == 1 ? true : false;
    });
    var seoRobotsInstructions = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_head_search_engine_instuctions");
    });
    var showCookieYes = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_head_cookies_cookieyes_enable") == 1 ? true : false;
    });
    var cookiesYesIdentifier = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_head_cookies_cookieyes_identifier");
    });
    var cookiesYesScript = function() {
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(cookiesYesIdentifier)) {
            return "https://cdn-cookieyes.com/client_data/" + cookiesYesIdentifier + "/script.js";
        }
        return null;
    };
    var rateParityHasLoaded = function() {
        if (true) {
            return document.getElementById("rp-allinone");
        }
        return true;
    };
    var cookieYesHasLoaded = function() {
        if (true) {
            return document.getElementsByClassName("cky-preference-center").length > 0;
        }
        return true;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (props.font != null) {
            var head = document.getElementsByTagName("head")[0];
            var style = document.createElement("style");
            var link = document.createElement("link");
            link.rel = "stylesheet";
            link.type = "text/css";
            switch(props.font){
                case "Roboto Slab":
                    link.href = "https://fonts.googleapis.com/css?family=Roboto+Slab&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', serif !important}";
                    break;
                case "Serif":
                    link.href = "https://fonts.googleapis.com/css?family=Roboto+Slab:300,400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', serif !important}";
                    break;
                case "Roboto":
                    link.href = "https://fonts.googleapis.com/css?family=Roboto:300,400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', sans-serif !important}";
                    break;
                case "Vollkorn":
                    link.href = "https://fonts.googleapis.com/css?family=Vollkorn:400,600,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Vollkorn', serif !important}";
                    break;
                case "Noto Sans":
                    link.href = "https://fonts.googleapis.com/css?family=Noto+Sans:400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Noto Sans', sans-serif !important}";
                    break;
                case "Cousine":
                    link.href = "https://fonts.googleapis.com/css?family=Cousine:400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', monospace !important}";
                    break;
                case "Playfair":
                    link.href = "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Playfair Display', serif !important}";
                    break;
                default:
                    link.href = "https://fonts.googleapis.com/icon?family=Material+Icons&display=swap";
                    break;
            }
            head.appendChild(link);
            head.appendChild(style);
        }
    });
    var googleSchema = {
        "@context": "https://schema.org/",
        "@type": "Organization",
        "name": "".concat(props.googleSchemaTitle),
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "".concat(props.googleSchemaStreetAddress),
            "addressLocality": "".concat(props.googleSchemaCity),
            "addressRegion": "".concat(props.googleSchemaCountry),
            "postalCode": "".concat(props.googleSchemaZip)
        },
        "telephone": "".concat(props.googleSchemaPhone)
    };
    var absoluteUrl = function(url) {
        if (!_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(url)) return null;
        if (/^https?:\/\//i.test(url)) return url;
        var isLocal = /(^|\.)(localhost|local)(:\d+)?(\/|$)/i.test(url);
        return (isLocal ? "http://" : "https://") + url.replace(/^\/+/, "");
    };
    var canonicalUrl = absoluteUrl(props.seoUrl);
    var pageUrl = canonicalUrl || props.domain;
    var pageSchema = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(props.image_fb_meta) ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        "@context": "https://schema.org/",
        "@type": "WebPage",
        "name": props.title
    }, pageUrl ? {
        "url": pageUrl
    } : {}), {
        "primaryImageOfPage": {
            "@type": "ImageObject",
            "url": props.image_fb_meta
        },
        "image": props.image_fb_meta
    }) : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: props.title
            }),
            props.keywords != null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: props.keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                content: props.titleOfficial
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(seoRobotsInstructions) ? seoRobotsInstructions : "index, follow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "theme-color",
                content: props.designColor
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "referrer",
                content: "strict-origin"
            }),
            canonicalUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            props.icon_60 != null && props.icon_60 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: props.icon_60
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: props.icon_60
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        href: props.icon_60
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        href: props.icon_60
                    })
                ]
            }),
            props.icon_76 != null && props.icon_76 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "76x76",
                href: props.icon_76
            }),
            props.icon_120 != null && props.icon_120 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "120x120",
                href: props.icon_120
            }),
            props.icon_152 != null && props.icon_152 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "152x152",
                href: props.icon_152
            }),
            props.icon_256 != null && props.icon_256 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/x-icon",
                        href: props.icon_256
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "shortcut icon",
                        type: "image/x-icon",
                        href: props.icon_256
                    })
                ]
            }),
            props.icon != null && props.icon != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                href: props.icon
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-mobile-web-app-capable",
                content: "yes"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-touch-fullscreen",
                content: "yes"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-mobile-web-app-status-bar-style",
                content: "default"
            }),
            props.manager == false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "type",
                content: "place"
            }),
            props.manager == false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "place"
            }),
            props.manager == false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:type",
                content: "place"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: props.site_name_fb_meta + " | " + props.title_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: props.site_name_fb_meta + " | " + props.title_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: props.site_name_fb_meta + " | " + props.title_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(props.desc_fb_meta) ? props.desc_fb_meta : props.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: props.desc_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: props.desc_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: props.image_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: props.image_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: props.image_fb_meta
            }),
            props.image_fb_meta_width != null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: String(props.image_fb_meta_width)
            }),
            props.image_fb_meta_height != null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: String(props.image_fb_meta_height)
            }),
            props.lat_fb_meta != null && props.lat_fb_meta != "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "place:location:latitude",
                content: props.lat_fb_meta
            }) : null,
            props.lon_fb_meta != null && props.lon_fb_meta != "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "place:location:longitude",
                content: props.lon_fb_meta
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "url",
                content: pageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: pageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:url",
                content: pageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: props.site_name_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image:alt",
                content: props.twitter_img_alt
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(googleSchema)
                }
            }),
            pageSchema && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(pageSchema)
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "manifest",
                href: manifestPath
            }),
            !cookieYesHasLoaded() && showCookieYes && cookiesYesScript != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                id: "cookieyes",
                type: "text/javascript",
                src: cookiesYesScript(),
                defer: true
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
            !rateParityHasLoaded() && !isRateParityWebAppPage && showRateParityWidget ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "text/javascript",
                    src: "https://code.rateparity.com/versions/installer.min.js",
                    defer: true
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (BuilderHead);


/***/ }),

/***/ 75858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MasonryType; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72462);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84849);
/* harmony import */ var _mui_lab__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45949);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55791);
/* harmony import */ var _ViewPort__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33030);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);











function MasonryType(props) {
    var dateLocale = (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useLocale */ .bU)();
    var builder = props.builder;
    var content = props.content;
    var articles = props.articles;
    var articlesLength = props.articlesLength;
    var container_class = "container";
    if (props.type == "blog" && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(builder.builder_news_view_width)) {
        container_class = builder.builder_news_view_width;
    } else if (props.type == "category" && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(content.category_view_width)) {
        container_class = content.category_view_width;
    }
    var skeletonArticles = [];
    for(var i = 0; i < 6; i++){
        skeletonArticles.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            height: 490,
            width: 265,
            className: "b-rad-md"
        }, i.toString()));
    }
    var textColor = function() {
        if (props.textColor) {
            return "text-light-color";
        }
        return;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(container_class, " pb-5"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "row w-100 m-0 ",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "col-12 p-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                    spacing: 2,
                    columns: props.columns || {
                        xs: 1,
                        sm: 2,
                        lg: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidArray */ .Z.isValidArray(articles) && articles.length < 4 ? articles.length : 4
                    },
                    children: props.loadingArticles ? skeletonArticles : _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidArray */ .Z.isValidArray(articles) && articles.map(function(article, index) {
                        var date_class = "opacity-60 mt-0 fs-13 ";
                        date_class += _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(article, "subtitle") ? "" : "m-0 ";
                        date_class += _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(article, "subtitle") || _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(article.image) ? "align-self-start" : "align-self-end";
                        var card_title_class = "card-title d-flex flex-column ";
                        card_title_class += _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(article, "subtitle") && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(article.image) ? "border-top m-0" : _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(article, "subtitle") && !_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(article.image) ? "border-bottom m-b-10" : "m-0";
                        var title_class = "";
                        title_class += _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(article, "subtitle") && !_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(article.image) ? "m-0" : _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(article, "subtitle") ? "mb-0" : "m-0";
                        var created = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(article, "subtitle") || _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(article.image) ? (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_2__/* .formatMomentDate */ .XY)(dateLocale, new Date(article.created * 1000), "dddd Do MMMM") : (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_2__/* .formatMomentDate */ .XY)(dateLocale, new Date(article.created * 1000), "MMM DD");
                        if (props.hasOwnProperty("articlesLimit") && (index < props.articlesLimit || props.articlesLimit === null) || !props.hasOwnProperty("articlesLimit")) {
                            var itemProps = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(props.fancyboxGroup) ? {
                                "data-fancybox": props.fancyboxGroup,
                                "data-src": article.fancyboxSrc || article.image,
                                "data-thumb": article.image,
                                "data-caption": article.caption
                            } : {
                                onClick: function() {
                                    return props.clickHandler(article);
                                }
                            };
                            var cardInner = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "card m-0 " + " " + (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(props.itemClassName) ? props.itemClassName : ""),
                                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                                    backgroundColor: props.backgroundColor != null ? props.backgroundColor : ""
                                }, props.hideCaption ? {
                                    borderRadius: "8px",
                                    overflow: "hidden"
                                } : {}),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: props.hideCaption ? {
                                            position: "relative"
                                        } : {
                                            height: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(article.image) ? 298 : "auto"
                                        },
                                        children: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(article.image) && (props.hideCaption ? // eslint-disable-next-line @next/next/no-img-element
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: article.image,
                                            alt: article.caption ? _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].removeEmojis */ .Z.removeEmojis(article.caption) : "Post Img",
                                            loading: "lazy",
                                            style: {
                                                width: "100%",
                                                display: "block"
                                            }
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                            // className="image"
                                            layout: "fill",
                                            sizes: "75vw",
                                            quality: "75",
                                            src: article.image,
                                            alt: article.caption ? _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].removeEmojis */ .Z.removeEmojis(article.caption) : "Post Img",
                                            placeholder: "blur",
                                            blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                        }))
                                    }),
                                    !props.hideCaption && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(article.image) ? "card-body d-flex flex-column-reverse" : "card-body d-flex flex-column",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: card_title_class,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                        className: textColor() + " " + title_class,
                                                        children: article.title
                                                    }),
                                                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(article, "tags") && !_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(article.image) && !_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(article, "subtitle") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: textColor() + " via",
                                                        children: article.tags
                                                    }),
                                                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidDate */ .Z.isValidDate(created) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                            className: textColor() + " " + date_class,
                                                            children: created.toString()
                                                        })
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                children: [
                                                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(article, "subtitle") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: textColor() + " line-clamp-2 m-0",
                                                            children: article.subtitle
                                                        })
                                                    }),
                                                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(article, "tags") && (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(article.image) || _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(article, "subtitle")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: textColor() + " " + (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(article.image) && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(article, "subtitle") ? "via m-b-10" : "via"),
                                                        children: article.tags
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            });
                            if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(props.fancyboxGroup)) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, itemProps), {
                                    className: props.setClass(""),
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: cardInner
                                }), article.id.toString());
                            }
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ViewPort__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                skeletonItem: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    height: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(article.image) ? 490 : 190,
                                    width: 265,
                                    className: "b-rad-md"
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                    href: props.updateHref(article),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, itemProps), {
                                        className: props.setClass(""),
                                        style: {
                                            cursor: article.has_description == "1" ? "pointer" : null
                                        },
                                        children: cardInner
                                    }), article.id.toString())
                                })
                            }, article.id.toString());
                        }
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 20276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Album; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./helpers/i18n.ts + 7 modules
var i18n = __webpack_require__(72462);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@fancyapps/ui/dist/fancybox.esm.js
var fancybox_esm = __webpack_require__(53569);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/index.mjs
var pro_regular_svg_icons = __webpack_require__(68779);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
// EXTERNAL MODULE: ./components/AppContext.tsx
var AppContext = __webpack_require__(7108);
// EXTERNAL MODULE: ./components/head/BuilderHead.tsx
var BuilderHead = __webpack_require__(948);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var class_Checkers = __webpack_require__(55791);
// EXTERNAL MODULE: ./components/templates/articles/types/MasonryType.tsx
var MasonryType = __webpack_require__(75858);
;// CONCATENATED MODULE: ./components/gallery/PropertyGalleryContent.tsx






var MAX_VISIBLE_FACILITIES = 4;
function FacilitiesLine(param) {
    var facilities = param.facilities;
    var t = (0,i18n/* useT */.NT)();
    var ref = (0,react.useState)(false), expanded = ref[0], setExpanded = ref[1];
    var hasMore = facilities.length > MAX_VISIBLE_FACILITIES;
    var visible = expanded || !hasMore ? facilities : facilities.slice(0, MAX_VISIBLE_FACILITIES);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "hint-text",
        children: [
            visible.join(" \xb7 "),
            hasMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    " \xb7 ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "javascript:void(0)",
                        className: "bold",
                        style: {
                            textDecoration: "underline",
                            color: "inherit"
                        },
                        onClick: function() {
                            return setExpanded(!expanded);
                        },
                        children: expanded ? t("common.showLess") : t("common.showMore")
                    })
                ]
            })
        ]
    });
}
function PropertyGalleryContent(param) {
    var albums = param.albums, propertyPhotos = param.propertyPhotos, onSelectAlbum = param.onSelectAlbum;
    var t = (0,i18n/* useT */.NT)();
    var validAlbums = (class_Checkers/* default.isValidArray */.Z.isValidArray(albums) ? albums : []).filter(function(album) {
        return class_Checkers/* default.isValidArray */.Z.isValidArray(album.photos);
    });
    var validPropertyPhotos = class_Checkers/* default.isValidArray */.Z.isValidArray(propertyPhotos) ? propertyPhotos : [];
    var allAlbums = validPropertyPhotos.length > 0 ? [
        {
            id: "main-photos",
            title: t("gallery.main"),
            photos: validPropertyPhotos
        }
    ].concat((0,_to_consumable_array/* default */.Z)(validAlbums)) : validAlbums;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [
            allAlbums.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "p-b-20 p-t-40",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "masonry",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mzn-grid mzn-grid-covers",
                        children: allAlbums.map(function(album) {
                            var cover = class_Checkers/* default.isValidArray */.Z.isValidArray(album.photos) ? album.photos[0] : null;
                            if (cover == null) {
                                return null;
                            }
                            var src = cover.image_thumb != undefined ? cover.image_thumb : cover.image;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "mzn-card",
                                href: "#gallery-" + album.id,
                                onClick: onSelectAlbum ? function(e) {
                                    e.preventDefault();
                                    onSelectAlbum(album.id);
                                } : undefined,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mzn-imgwrap",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: src,
                                            alt: album.title,
                                            loading: "lazy"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mzn-caption fs-12",
                                        children: album.title
                                    })
                                ]
                            }, album.id);
                        })
                    })
                })
            }),
            allAlbums.map(function(album) {
                return class_Checkers/* default.isValidArray */.Z.isValidArray(album.photos) && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "p-t-30 p-b-30",
                    id: "gallery-" + album.id,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "masonry",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-md-4 mzn-gallery-info mb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "mb-0",
                                            children: album.title
                                        }),
                                        class_Checkers/* default.isValidString */.Z.isValidString(album.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "hint-text",
                                            children: album.description
                                        }),
                                        class_Checkers/* default.isValidArray */.Z.isValidArray(album.facilities) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FacilitiesLine, {
                                            facilities: album.facilities
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-8 mzn-gallery-photos",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MasonryType["default"], {
                                        type: "gallery",
                                        content: {},
                                        builder: {},
                                        textColor: false,
                                        backgroundColor: null,
                                        itemClassName: "",
                                        loadingArticles: false,
                                        articlesLimit: null,
                                        fancyboxGroup: "album-all",
                                        hideCaption: true,
                                        columns: {
                                            xs: 1,
                                            sm: 2
                                        },
                                        setClass: function() {
                                            return "";
                                        },
                                        articles: album.photos.map(function(photo, index) {
                                            var caption = class_Checkers/* default.isValidString */.Z.isValidString(photo.caption) ? photo.caption.trim() : "";
                                            var src = photo.image_thumb != undefined ? photo.image_thumb : photo.image;
                                            var photoKey = photo.id != null ? photo.id : photo.image_id != null ? photo.image_id : src;
                                            return {
                                                id: photoKey != null ? photoKey.toString() : src,
                                                title: caption || album.title + " photo " + (index + 1),
                                                caption: caption,
                                                image: src,
                                                fancyboxSrc: photo.image,
                                                has_description: "0"
                                            };
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }, album.id);
            })
        ]
    });
}

;// CONCATENATED MODULE: ./helpers/FacilitiesHelper.ts

var FacilitiesHelper_MAX_VISIBLE_FACILITIES = 4;
function facilitiesSummary(facilities) {
    if (!Checkers.isValidArray(facilities)) {
        return null;
    }
    var visible = facilities.slice(0, FacilitiesHelper_MAX_VISIBLE_FACILITIES);
    var rest = facilities.length - visible.length;
    return visible.join(" \xb7 ") + (rest > 0 ? " \xb7 +" + rest + " more" : "");
}
function mergeFacilities(areas) {
    if (!Checkers.isValidArray(areas)) {
        return [];
    }
    return Array.from(new Set(areas.flatMap(function(area) {
        return Checkers.isValidArray(area.facilities) ? area.facilities : [];
    })));
}
function featureGroupsToFacilities(groups) {
    if (!class_Checkers/* default.isValidArray */.Z.isValidArray(groups)) {
        return [];
    }
    var labels = [];
    groups.forEach(function(group) {
        (class_Checkers/* default.isValidArray */.Z.isValidArray(group.features) ? group.features : []).forEach(function(feature) {
            if (!class_Checkers/* default.isValidString */.Z.isValidString(feature.feature_title)) {
                return;
            }
            var label = feature.feature_title;
            if (class_Checkers/* default.isValidArray */.Z.isValidArray(feature.feature_options) && class_Checkers/* default.isValidString */.Z.isValidString(feature.feature_options[0].option_value)) {
                label += " " + feature.feature_options[0].option_value;
            } else if (feature.feature_value != null && String(feature.feature_value) !== "1" && String(feature.feature_value).trim() !== "" && !Array.isArray(feature.feature_value)) {
                label += " " + feature.feature_value;
            }
            labels.push(label.replace(/\s+/g, " ").trim());
        });
    });
    return labels;
}

// EXTERNAL MODULE: ./api/client.ts
var client = __webpack_require__(57093);
;// CONCATENATED MODULE: ./pages/album/index.tsx





















var waitForScrollToTop = function() {
    var maxWaitMs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1500;
    return new Promise(function(resolve) {
        if (window.scrollY <= 0) {
            resolve();
            return;
        }
        var start = Date.now();
        var check = function() {
            if (window.scrollY <= 0 || Date.now() - start > maxWaitMs) {
                resolve();
                return;
            }
            requestAnimationFrame(check);
        };
        requestAnimationFrame(check);
    });
};
var __N_SSP = true;
function Album(props) {
    var t = (0,i18n/* useT */.NT)();
    var router = (0,next_router.useRouter)();
    var handleBack = function() {
        router.back();
    };
    var pageContext = (0,react.useContext)(AppContext/* page */.M);
    pageContext.pageId = props.app_data.page_id;
    pageContext.isMobile = props.isMobile;
    pageContext.isTablet = props.isTablet;
    pageContext.isDesktop = props.isDesktop;
    pageContext.appSettings = props.app;
    var ref = (0,react.useState)(null), urlHref = ref[0], setUrlHref = ref[1];
    react.useEffect(function() {
        if (window !== undefined) {
            setUrlHref(window.location.href);
        }
    }, [
        urlHref
    ]);
    var domain = props.domain;
    var app = props.app;
    var head = props.head;
    var content = props.content;
    var chainProperties = class_Checkers/* default.isValidArray */.Z.isValidArray(props.chainProperties) ? props.chainProperties : null;
    var ref1;
    var ref2 = (0,react.useState)((ref1 = content === null || content === void 0 ? void 0 : content.property_id) !== null && ref1 !== void 0 ? ref1 : null), activePropertyId = ref2[0], setActivePropertyId = ref2[1];
    var ref3 = (0,react.useState)(class_Checkers/* default.isValidArray */.Z.isValidArray(content === null || content === void 0 ? void 0 : content.album) ? content.album : []), activePropertyPhotos = ref3[0], setActivePropertyPhotos = ref3[1];
    var ref4 = (0,react.useState)((class_Checkers/* default.isValidArray */.Z.isValidArray(props.albums) ? props.albums : []).filter(function(album) {
        return class_Checkers/* default.isValidArray */.Z.isValidArray(album.photos);
    })), activeAlbums = ref4[0], setActiveAlbums = ref4[1];
    var ref5 = (0,react.useState)(false), tabLoading = ref5[0], setTabLoading = ref5[1];
    var ref6;
    var lastSyncedContentPropertyId = react.useRef((ref6 = content === null || content === void 0 ? void 0 : content.property_id) !== null && ref6 !== void 0 ? ref6 : null);
    var contentIsStale = (content === null || content === void 0 ? void 0 : content.property_id) != null && content.property_id !== lastSyncedContentPropertyId.current;
    (0,react.useEffect)(function() {
        if ((content === null || content === void 0 ? void 0 : content.property_id) == null || content.property_id === lastSyncedContentPropertyId.current) return;
        lastSyncedContentPropertyId.current = content.property_id;
        setActivePropertyId(content.property_id);
        setActivePropertyPhotos(class_Checkers/* default.isValidArray */.Z.isValidArray(content.album) ? content.album : []);
        setActiveAlbums((class_Checkers/* default.isValidArray */.Z.isValidArray(props.albums) ? props.albums : []).filter(function(album) {
            return class_Checkers/* default.isValidArray */.Z.isValidArray(album.photos);
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        content === null || content === void 0 ? void 0 : content.property_id
    ]);
    var handleTabClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(propertyId) {
            var selectedProperty, propertySlug, nextQuery, ref, mediaRes, albumsRes, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (propertyId === activePropertyId) return [
                            2
                        ];
                        if (!(window.scrollY > 0)) return [
                            3,
                            2
                        ];
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        });
                        return [
                            4,
                            waitForScrollToTop()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        setActivePropertyId(propertyId);
                        setTabLoading(true);
                        selectedProperty = chainProperties === null || chainProperties === void 0 ? void 0 : chainProperties.find(function(p) {
                            return p.id === propertyId;
                        });
                        propertySlug = class_Checkers/* default.isValidString */.Z.isValidString(selectedProperty === null || selectedProperty === void 0 ? void 0 : selectedProperty.sourcePath) ? selectedProperty.sourcePath.replace(/^\/+/, "") : propertyId;
                        nextQuery = (0,_object_spread/* default */.Z)({}, router.query);
                        delete nextQuery.property_id;
                        router.replace({
                            pathname: router.pathname,
                            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, nextQuery), {
                                property: propertySlug
                            })
                        }, undefined, {
                            shallow: true
                        });
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            Promise.all([
                                (0,client/* getPropertyMedia */.DV)(props.app_data.page_id, propertyId),
                                (0,client/* getPropertyAlbums */.wx)(props.app_data.page_id, propertyId)
                            ])
                        ];
                    case 4:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), mediaRes = ref[0], albumsRes = ref[1];
                        setActivePropertyPhotos(class_Checkers/* default.isValidArray */.Z.isValidArray(mediaRes === null || mediaRes === void 0 ? void 0 : mediaRes.images) ? mediaRes.images : []);
                        setActiveAlbums((class_Checkers/* default.isValidArray */.Z.isValidArray(albumsRes === null || albumsRes === void 0 ? void 0 : albumsRes.albums) ? albumsRes.albums : []).filter(function(album) {
                            return class_Checkers/* default.isValidArray */.Z.isValidArray(album.photos);
                        }));
                        return [
                            3,
                            6
                        ];
                    case 5:
                        e = _state.sent();
                        setActivePropertyPhotos([]);
                        setActiveAlbums([]);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        setTabLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleTabClick(propertyId) {
            return _ref.apply(this, arguments);
        };
    }();
    var propertyPhotos = activePropertyPhotos;
    var albums = activeAlbums;
    var ref7 = (0,react.useState)([]), bedroomAlbums = ref7[0], setBedroomAlbums = ref7[1];
    var ref8 = (0,react.useState)([]), spaceAlbums = ref8[0], setSpaceAlbums = ref8[1];
    var ref9 = (0,react.useState)([]), poolAlbums = ref9[0], setPoolAlbums = ref9[1];
    var ref10 = (0,react.useState)(activePropertyId != null), galleryLoading = ref10[0], setGalleryLoading = ref10[1];
    (0,react.useEffect)(function() {
        var propertyId = activePropertyId;
        if (propertyId == null) {
            setGalleryLoading(false);
            return;
        }
        setGalleryLoading(true);
        var cancelled = false;
        var bedroomsPromise = (0,client/* getPropertyBedrooms */.Wd)(props.app_data.page_id, propertyId).then(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(res) {
                var bedrooms, details, nextBedroomAlbums;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            bedrooms = (class_Checkers/* default.isValidArray */.Z.isValidArray(res === null || res === void 0 ? void 0 : res.bedrooms) ? res.bedrooms : []).filter(function(b) {
                                return /^\d+$/.test(String(b.bedroom_id));
                            });
                            if (cancelled || bedrooms.length === 0) return [
                                2
                            ];
                            return [
                                4,
                                Promise.all(bedrooms.map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(b) {
                                        var detailRes, e;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _state.trys.push([
                                                        0,
                                                        2,
                                                        ,
                                                        3
                                                    ]);
                                                    return [
                                                        4,
                                                        (0,client/* getPropertyBedroomById */.Qv)(props.app_data.page_id, propertyId, b.bedroom_id)
                                                    ];
                                                case 1:
                                                    detailRes = _state.sent();
                                                    return [
                                                        2,
                                                        class_Checkers/* default.isValidArray */.Z.isValidArray(detailRes === null || detailRes === void 0 ? void 0 : detailRes.bedrooms) ? detailRes.bedrooms[0] : null
                                                    ];
                                                case 2:
                                                    e = _state.sent();
                                                    return [
                                                        2,
                                                        null
                                                    ];
                                                case 3:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(b) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 1:
                            details = _state.sent();
                            if (cancelled) return [
                                2
                            ];
                            nextBedroomAlbums = bedrooms.map(function(b, index) {
                                var detail = details[index];
                                var photos = detail != null && class_Checkers/* default.isValidArray */.Z.isValidArray(detail.media) ? detail.media : [];
                                if (photos.length === 0) return null;
                                return {
                                    id: "bedroom-" + b.bedroom_id,
                                    title: class_Checkers/* default.isValidString */.Z.isValidString(b.bedroom_title) ? b.bedroom_title : t("bedroom.numbered", {
                                        n: index + 1
                                    }),
                                    photos: photos,
                                    sort: parseFloat(b.bedroom_sort),
                                    facilities: featureGroupsToFacilities(detail.features)
                                };
                            }).filter(function(a) {
                                return a != null;
                            });
                            setBedroomAlbums(nextBedroomAlbums);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(res) {
                return _ref.apply(this, arguments);
            };
        }()).catch(function() {
            return undefined;
        });
        var spacesPromise = (0,client/* getPropertySpaces */.Eo)(props.app_data.page_id, propertyId).then(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(res) {
                var spaces, details, nextSpaceAlbums;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            spaces = class_Checkers/* default.isValidArray */.Z.isValidArray(res === null || res === void 0 ? void 0 : res.spaces) ? res.spaces : [];
                            if (cancelled || spaces.length === 0) return [
                                2
                            ];
                            return [
                                4,
                                Promise.all(spaces.map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(s) {
                                        var detailRes, e;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _state.trys.push([
                                                        0,
                                                        2,
                                                        ,
                                                        3
                                                    ]);
                                                    return [
                                                        4,
                                                        (0,client/* getPropertySpaces */.Eo)(props.app_data.page_id, propertyId, "space_id=" + s.space_id)
                                                    ];
                                                case 1:
                                                    detailRes = _state.sent();
                                                    return [
                                                        2,
                                                        class_Checkers/* default.isValidArray */.Z.isValidArray(detailRes === null || detailRes === void 0 ? void 0 : detailRes.spaces) ? detailRes.spaces[0] : null
                                                    ];
                                                case 2:
                                                    e = _state.sent();
                                                    return [
                                                        2,
                                                        null
                                                    ];
                                                case 3:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(s) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 1:
                            details = _state.sent();
                            if (cancelled) return [
                                2
                            ];
                            nextSpaceAlbums = spaces.map(function(s, index) {
                                var detail = details[index];
                                var photos = detail != null && class_Checkers/* default.isValidArray */.Z.isValidArray(detail.media) ? detail.media : [];
                                if (photos.length === 0) return null;
                                return {
                                    id: "space-" + s.space_id,
                                    title: class_Checkers/* default.isValidString */.Z.isValidString(s.space_title) ? s.space_title : t("gallery.spaceNumbered", {
                                        n: index + 1
                                    }),
                                    photos: photos,
                                    sort: parseFloat(s.space_sort),
                                    facilities: featureGroupsToFacilities(detail.features)
                                };
                            }).filter(function(a) {
                                return a != null;
                            });
                            setSpaceAlbums(nextSpaceAlbums);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(res) {
                return _ref.apply(this, arguments);
            };
        }()).catch(function() {
            return undefined;
        });
        var poolsPromise = (0,client/* getPropertyPools */.qo)(props.app_data.page_id, propertyId).then(function(res) {
            if (cancelled) return;
            var pools = class_Checkers/* default.isValidArray */.Z.isValidArray(res === null || res === void 0 ? void 0 : res.pools) ? res.pools : [];
            setPoolAlbums(pools.filter(function(p) {
                return class_Checkers/* default.isValidArray */.Z.isValidArray(p.media);
            }).map(function(p, index) {
                return {
                    id: "pool-" + p.pool_id,
                    title: class_Checkers/* default.isValidString */.Z.isValidString(p.pool_title) ? p.pool_title : t("gallery.poolNumbered", {
                        n: index + 1
                    }),
                    photos: p.media,
                    sort: parseFloat(p.pool_sort),
                    facilities: featureGroupsToFacilities(p.features)
                };
            }));
        }).catch(function() {
            return undefined;
        });
        Promise.all([
            bedroomsPromise,
            spacesPromise,
            poolsPromise
        ]).finally(function() {
            if (!cancelled) setGalleryLoading(false);
        });
        return function() {
            cancelled = true;
        };
    }, [
        activePropertyId,
        props.app_data.page_id
    ]);
    var bySort = function(list) {
        return (0,_to_consumable_array/* default */.Z)(list).sort(function(a, b) {
            var sa = Number.isFinite(a.sort) ? a.sort : Infinity;
            var sb = Number.isFinite(b.sort) ? b.sort : Infinity;
            return sa === sb ? 0 : sa - sb;
        });
    };
    var allAlbumsForDisplay = (0,react.useMemo)(function() {
        var isCommonArea = function(album) {
            return /shared|common/i.test(album.title);
        };
        return (0,_to_consumable_array/* default */.Z)(albums).concat((0,_to_consumable_array/* default */.Z)(bySort(spaceAlbums)), (0,_to_consumable_array/* default */.Z)(bySort(bedroomAlbums.filter(function(a) {
            return !isCommonArea(a);
        }))), (0,_to_consumable_array/* default */.Z)(bySort(bedroomAlbums.filter(isCommonArea))), (0,_to_consumable_array/* default */.Z)(bySort(poolAlbums)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(albums.map(function(a) {
            return a.id;
        })),
        spaceAlbums,
        bedroomAlbums,
        poolAlbums
    ]);
    var allAlbums = (0,react.useMemo)(function() {
        return propertyPhotos.length > 0 ? [
            {
                id: "main gallery",
                title: t("gallery.main"),
                photos: propertyPhotos
            }
        ].concat((0,_to_consumable_array/* default */.Z)(allAlbumsForDisplay)) : allAlbumsForDisplay;
    }, [
        propertyPhotos,
        allAlbumsForDisplay
    ]);
    var image_fb_meta = class_Checkers/* default.isValidArray */.Z.isValidArray(head.og_image) ? head.og_image[0].image : null;
    (0,react.useEffect)(function() {
        fancybox_esm/* Fancybox.bind */.KR.bind('[data-fancybox^="album-"]', {
            Hash: false
        });
        return function() {
            fancybox_esm/* Fancybox.unbind */.KR.unbind('[data-fancybox^="album-"]');
            fancybox_esm/* Fancybox.close */.KR.close();
        };
    }, [
        allAlbums
    ]);
    var tabsData = albums.map(function(album) {
        return {
            tabId: "album" + album.id,
            tabTitle: album.title,
            tabContent: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mzn-grid",
                children: class_Checkers/* default.isValidArray */.Z.isValidArray(album.photos) && album.photos.map(function(photo, index) {
                    var caption = class_Checkers/* default.isValidString */.Z.isValidString(photo.caption) ? photo.caption.trim() : "";
                    var src = photo.image_thumb != undefined ? photo.image_thumb : photo.image;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mzn-card",
                        "data-fancybox": "album-" + album.id,
                        "data-src": photo.image,
                        "data-thumb": src,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mzn-imgwrap",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: src,
                                    alt: caption || t("gallery.imageNumbered", {
                                        n: index + 1
                                    }),
                                    loading: "lazy"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mzn-caption fs-12",
                                children: caption.length > 0 ? caption : t("gallery.photoNumbered", {
                                    n: index + 1
                                })
                            })
                        ]
                    }, photo.id != null ? photo.id.toString() : src);
                })
            })
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderHead/* default */.Z, {
                title: head.data.title + " - " + head.data.motto,
                keywords: head.data.meta_keywords,
                titleOfficial: head.data.titleOfficial,
                domain: urlHref,
                icon_60: head.data.icon_60,
                icon_76: head.data.icon_76,
                icon_120: head.data.icon_120,
                icon_152: head.data.icon_152,
                icon_256: head.data.icon_256,
                icon: head.data.icon,
                title_fb_meta: head.data.title + " - " + head.data.motto,
                desc_fb_meta: head.data.meta_description,
                image_fb_meta: image_fb_meta,
                site_name_fb_meta: head.data.title,
                lat_fb_meta: head.location.latitude,
                lon_fb_meta: head.location.longitude,
                twitter_img_alt: head.data.title + " - " + head.data.motto + ". " + head.data.meta_description,
                googleSchemaContext: domain,
                googleSchemaTitle: head.data.title,
                googleSchemaStreetAddress: head.location.address,
                googleSchemaCity: head.location.city,
                googleSchemaCountry: head.location.country,
                googleSchemaZip: head.location.zip,
                googleSchemaPhone: head.location.phone,
                designColor: app.designColor,
                font: app.font,
                manager: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    position: "sticky",
                    top: 0,
                    background: "#fff",
                    zIndex: 1
                },
                className: "jsx-775fc9bba9c7a5f1" + " " + "p-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            position: "relative"
                        },
                        className: "jsx-775fc9bba9c7a5f1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: handleBack,
                                "aria-label": t("a11y.back"),
                                style: {
                                    position: "absolute",
                                    left: 0,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    zIndex: 2
                                },
                                className: "jsx-775fc9bba9c7a5f1" + " " + "btn btn-link text-dark",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: pro_regular_svg_icons/* faArrowLeft */.acZ,
                                    className: "fs-20"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "jsx-775fc9bba9c7a5f1" + " " + "h5 text-center m-0",
                                children: t("gallery.title")
                            })
                        ]
                    }),
                    chainProperties != null && chainProperties.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        role: "tablist",
                        className: "jsx-775fc9bba9c7a5f1" + " " + "nav nav-tabs w-100 nav-tabs-simple-bold album-tabs",
                        children: chainProperties.map(function(property) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "jsx-775fc9bba9c7a5f1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "#",
                                    onClick: function(e) {
                                        e.preventDefault();
                                        handleTabClick(property.id);
                                    },
                                    className: "jsx-775fc9bba9c7a5f1" + " " + ("fs-12" + (property.id === activePropertyId ? " active" : "") + (tabLoading ? " disabled" : "") || 0),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "jsx-775fc9bba9c7a5f1",
                                        children: property.title
                                    })
                                })
                            }, property.id);
                        })
                    }),
                    (0,jsx_runtime.jsx)((style_default()), {
                        id: "775fc9bba9c7a5f1",
                        children: ".album-tabs.jsx-775fc9bba9c7a5f1:after{display:none}@media(max-width:767px){.album-tabs.jsx-775fc9bba9c7a5f1{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;overflow-x:auto;-webkit-overflow-scrolling:touch;-webkit-box-pack:start;-webkit-justify-content:flex-start;-moz-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;padding-bottom:12px}.album-tabs.jsx-775fc9bba9c7a5f1>li.jsx-775fc9bba9c7a5f1{-webkit-box-flex:0;-webkit-flex:0 0 auto;-moz-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}}@media(min-width:768px){.album-tabs.jsx-775fc9bba9c7a5f1{-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}}"
                    })
                ]
            }),
            (galleryLoading || contentIsStale) && !tabLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "p-b-20 p-t-40",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "masonry",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mzn-grid mzn-grid-covers",
                                children: Array.from({
                                    length: 8
                                }).map(function(_, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mzn-card",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mzn-imgwrap",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                    height: "100%",
                                                    containerClassName: "d-block h-100"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mzn-caption fs-12",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                    width: 70
                                                })
                                            })
                                        ]
                                    }, i);
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "p-t-30 p-b-30",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "masonry",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4 mzn-gallery-info mb-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "mb-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                width: 160
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-8 mzn-gallery-photos",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                display: "grid",
                                                gridTemplateColumns: "repeat(2, 1fr)",
                                                gap: 16
                                            },
                                            children: Array.from({
                                                length: 6
                                            }).map(function(_, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                    height: 220,
                                                    containerClassName: "d-block"
                                                }, i);
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyGalleryContent, {
                albums: allAlbumsForDisplay,
                propertyPhotos: propertyPhotos
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2828,8051,1682,5949,9960,9774,2888,179], function() { return __webpack_exec__(81299); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);